export default "__VITE_ASSET__04JWjQZM__"